import { CONSENT_STORAGE_KEY, CONSENT_VERSION, type ConsentPreferences } from "./consentTypes";

const isIsoDate = (value: unknown): value is string => {
  if (typeof value !== "string" || !value) {
    return false;
  }
  return !Number.isNaN(Date.parse(value));
};

export const buildConsentPreferences = (
  values: Pick<ConsentPreferences, "analytics" | "advertising">,
  updatedAt = new Date().toISOString(),
): ConsentPreferences => ({
  necessary: true,
  analytics: Boolean(values.analytics),
  advertising: Boolean(values.advertising),
  version: CONSENT_VERSION,
  updatedAt,
});

export const validateConsentPreferences = (value: unknown): ConsentPreferences | null => {
  if (!value || typeof value !== "object") {
    return null;
  }
  const candidate = value as Partial<ConsentPreferences>;
  if (
    candidate.necessary !== true ||
    typeof candidate.analytics !== "boolean" ||
    typeof candidate.advertising !== "boolean" ||
    candidate.version !== CONSENT_VERSION ||
    !isIsoDate(candidate.updatedAt)
  ) {
    return null;
  }
  return {
    necessary: true,
    analytics: candidate.analytics,
    advertising: candidate.advertising,
    version: CONSENT_VERSION,
    updatedAt: candidate.updatedAt,
  };
};

export const readStoredConsentPreferences = (): ConsentPreferences | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return validateConsentPreferences(JSON.parse(raw));
  } catch {
    return null;
  }
};

export const saveConsentPreferences = (preferences: ConsentPreferences): void => {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(preferences));
};
